import _spinners from "./spinners.json";
var exports = {};
const spinners = Object.assign({}, _spinners); // eslint-disable-line import/extensions

const spinnersList = Object.keys(spinners);
Object.defineProperty(spinners, "random", {
  get() {
    const randomIndex = Math.floor(Math.random() * spinnersList.length);
    const spinnerName = spinnersList[randomIndex];
    return spinners[spinnerName];
  }
});
exports = spinners;
export default exports;